/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface AuditRequest {
    activity: AuditActivityEnum;
}

/**
 * AuditApi - interface
 * 
 * @export
 * @interface AuditApiInterface
 */
export interface AuditApiInterface {
    /**
     * Send information for user activity audit logs
     * @summary / audit
     * @param {'Login' | 'Logout' | 'View' | 'Search' | 'Report: File Format' | 'Report: Information Packages Ingested'} activity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    auditRaw(requestParameters: AuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send information for user activity audit logs
     * / audit
     */
    audit(requestParameters: AuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class AuditApi extends runtime.BaseAPI implements AuditApiInterface {

    /**
     * Send information for user activity audit logs
     * / audit
     */
    async auditRaw(requestParameters: AuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.activity === null || requestParameters.activity === undefined) {
            throw new runtime.RequiredError('activity','Required parameter requestParameters.activity was null or undefined when calling audit.');
        }

        const queryParameters: any = {};

        if (requestParameters.activity !== undefined) {
            queryParameters['activity'] = requestParameters.activity;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/audit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send information for user activity audit logs
     * / audit
     */
    async audit(requestParameters: AuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.auditRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const AuditActivityEnum = {
    Login: 'Login',
    Logout: 'Logout',
    View: 'View',
    Search: 'Search',
    ReportFileFormat: 'Report: File Format',
    ReportInformationPackagesIngested: 'Report: Information Packages Ingested'
} as const;
export type AuditActivityEnum = typeof AuditActivityEnum[keyof typeof AuditActivityEnum];
